import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useNavigate, useLocation, Routes, Route, Navigate } from 'react-router-dom';
import { Title } from 'react-admin';
import { DropInSessions } from './DropInSessions';

export const Activity: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getTabValue = () => {
    if (location.pathname.includes('/drop-in')) return 0;
    return 0;
  };

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        navigate('/activity/drop-in');
        break;
      default:
        navigate('/activity/drop-in');
        break;
    }
  };

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      <Title title="Activity" />

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={getTabValue()} onChange={handleTabChange}>
          <Tab label="Drop In" />
        </Tabs>
      </Box>

      <Routes>
        <Route path="drop-in" element={<DropInSessions />} />
        <Route path="/" element={<Navigate to="/activity/drop-in" replace />} />
      </Routes>
    </Box>
  );
};
